<template>
    <Row :gutter="8">
        <template v-if="deviceList.length > 0">
            <Col :xxl="{span: 4}" :xl="{span:4}" :lg="{span: 6}" :md="{span:6}" :xs="{span:6}"
                 v-for="(item,index) in deviceList" :key="`${item.id}_${index}`">
                <!-- 每个设备卡  片 -->
                <Card id="lift-card" class="lift-groups-card margin-bottom-5"
                      :class="[{expire:item.isExpire==0,fault: item.broken && item.online, online: item.online}]">
                    <div @mouseover="mouseEnter(item)" @mouseleave="mouseLeave(item)" class="full">
                        <!-- 动画显示、隐藏 -->
                        <transition name="slide-fade">
                            <!---->
                            <div v-if="item.transtionShow" class="menu-box">
                                <res-view :keyName="'fun_device_update'">
                                    <img @click.stop="onDeviceMenu('edit',index)" class="more" :title="$t('l.edit')"
                                         src="/images/device/micon/bianji.png" alt="">
                                </res-view>
                                <res-view :keyName="'fun_device_delete'">
                                    <img @click.stop="onDeviceMenu('delete',index)"
                                         class="more margin-left-5 margin-right-5" :title="$t('l.delete')"
                                         src="/images/device/micon/shanchu.png" alt="">
                                </res-view>
                                <img @click.stop="onDeviceMenu('qrcode',index)" class="more"
                                     :title="$t('l.device_qrcode')"
                                     src="/images/device/micon/二维码.svg" alt="">
                            </div>
                        </transition>
                        <!-- 电梯内容 -->
                        <div @click.stop="detailLift(item)" class="lift-content">
                            <div>
                                <!-- 收藏与未收藏 -->
                                <div class="like-icon" @click="preUnlike(index, $event)">
                                    <img v-if="likes.includes(item.id)" src="images/device/like.png" :alt="$t('l.focus')"
                                         :title="`[${item.name}]\n${$t('l.remark165')}`">
                                    <template v-if="$ifauth('fun_device_add_like')&&!likes.includes(item.id)">
                                        <img src="images/device/un_like.png" :alt="$t('l.no_focus')"
                                             :title="`${$t('l.click_focus')}[${item.name}]`">
                                    </template>
                                </div>
                                <div class="device-type-icon">
                                    <img src="images/device/lift-icon.png"/>
                                </div>
                                <template v-if="item.terminal_id">
                                    <div style="display: flex; margin-top:2px">
                                        <div v-if="item.terminal_id.startsWith('E')" class="terminal_type">WCR</div>
                                        <div v-else-if="item.terminal_id.startsWith('W')&&item.terminal_type==0"
                                             class="terminal_type">
                                            WCR
                                        </div>
                                        <div v-else-if="item.terminal_id.startsWith('W')&&!item.terminal_type"
                                             class="terminal_type">TWCR
                                        </div>
                                        <div v-else-if="item.terminal_id.startsWith('W')&&item.terminal_type==1"
                                             class="terminal_type">TWCR
                                        </div>
                                        <div v-else class="terminal_type">VWCR</div>
                                        <span v-if="showMonitor"
                                              class="lift-floor-now margin-left-5 ">{{item.current_status.floor_current}}</span>
                                    </div>
                                </template>
                            </div>
                            <!-- 电梯名字等信息 -->
                            <div class="device-status-icons">
                                    <span class="item-name">{{item.name}}</span>
                                <span  class="icon-online-status">
                                    <template  v-if="item.current_status.run_status">
                                        <img :src="`images/device/status/status${item.current_status.run_status}.png`"
                                              :title="runStatus[item.current_status.run_status]">
                                    </template>
                                    <template v-if="item.online == 0">
                                        <img src="images/device/status/offline.png"
                                             :title="$t('l.offline')">
                                    </template>
                                    <template v-if="item.isExpire == 0">
                                          <img class="guoqitixing"
                                               src="images/device/status/guoqitixing.png"
                                               :title="$t('l.ExpireCount')">
                                    </template>
                                </span>
                                <div class="capa-icons">
                                    <template v-if="item.j_extra_capacity&&item.j_extra_capacity.length>0">
                                        <img v-for="(imgitem,it) in extraConfig" :key="it"
                                             :src="'images/device/micon/'+imgitem.icon+'.png'"
                                             v-if="item.j_extra_capacity.includes(imgitem.index)" :title="imgitem.value">
                                    </template>
                                </div>

                            </div>

<!--                          2025年7月28日   推送方案名称-->

                        </div>
                        <!-- 底部滚动 -->
                        <lg-marquee class="bottom-info" :text="getDeviceShowName(item)"></lg-marquee>
                    </div>
                </Card>
            </Col>
        </template>
    </Row>
</template>

<script>
    import ResView from "../../my-components/res-view";
    import LgMarquee from "../../my-components/lg-marquee";
    import util from '@/libs/util';
    import extraConfig from '../../../constant-data/extra-config';

    export default {
        name: "lift-groups",
        components: {LgMarquee, ResView},
        props: {
            pageNum: Number,
            deviceList: Array,
            allTagsArray: Array,
            communityMap: Object,
            likes: Array,
            showMonitor: Boolean
        },
        data() {
            return {
                transtionShow: false,
                extraConfig,
                ifDeleteDevice: false,
                width: Math.floor((document.body.clientWidth - 24) / 232) * 232 + "px",//宽
                textWidth: 0, // 字符长度
                isScroll: false, // 是否滚动
                ifShowTranscript: false,
                ifShowTranscriptText: false,
                timer: {},
                scroll: 0,
                distance: 0,  // 设置初始位移距离
            }
        },
        methods: {
            detailLift(device) {
                // MARK_MODIFY_ONLINE20200525
                this.$router.push(
                    {
                        name: 'page_lift_monitor',
                        params: {
                            device, id: device.id,
                            page: this.pageNum,
                            terminal_id: device.terminal_id ? device.terminal_id : device.vm_device_id,
                            terminal_id_curve: device.terminal_id_curve,
                            online: device.online,
                            status: device.online ? 'online' : 'offline'
                        }
                    })
            },
            // getStatusSrc(device) {
            //     // MARK_MODIFY_ONLINE20200525
            //     return device.online ?
            //         "public/image/icons/online.png" :
            //         "public/image/icons/offline.png"
            // },
            getDeviceShowName(device) {
                let deviceName = device.name + (device.code ? `【${device.code}】` : '');
                let community = this.communityMap[device.community_id];
                if (!community) return deviceName;
                let emptyObj = {name: ''};
                let location = device.j_location;
                if (!location) return community.name + '-' + deviceName;
                location.building = location.building || emptyObj;
                location.unit = location.unit || emptyObj;
                location.door = location.door || emptyObj;
                if (device.address) {
                    return community.name + ' ' + location.building.name + ' ' + location.unit.name + ' ' + location.door.name + device.address;
                }
                return community.name + ' ' + location.building.name + ' ' + location.unit.name + ' ' + location.door.name + ' 【' + community.j_region.province.name + community.j_region.city.name + (community.j_region.area ? community.j_region.area.name : '') + community.address + '】';
            },
            onDeviceMenu(name, index) {
                let device = this.deviceList[index];
                let param = {};
                switch (name) {
                    case 'batch':
                        param.item = device;
                        param.index = index;
                        this.$emit('addBatch', param)
                        break;
                    case 'delete':
                        this.$Modal.confirm({
                            title: this.$t('l.warn'),
                            content: '<p>' + this.$t('l.hint39') + '</p>',
                            onOk: () => {
                                this.$emit("delete", device.id)
                            },
                        })
                        break;
                    case 'edit':
                        this.$emit('on-edit', {device, index});
                        break;
                    case 'pay':
                        // this.$emit('on-pay',{device, index})
                        this.$Message.warning(this.$t('l.hint40'))
                        break;
                    case 'unlike':
                        this.$emit('on-unlike', index);
                        break;
                    // case 'warn_config':
                    //     this.$emit('on-warnconfig', device);
                    //     break;
                  case 'qrcode':
                    this.$emit('on-qrcode', device);
                    break;
                }
            },
            preUnlike(index, evt) {
                evt.stopPropagation()
                var device = this.deviceList[index];
                if (!device) return;
                let isLike = this.likes.includes(device.id)
                if (isLike) { // 取消 关注
                    this.$Modal.confirm({
                        content: this.$t('l.no_focus') + ` ${device.name} ？`,
                        onOk: () => {
                            this.$emit('on-unlike', index);
                        }
                    })
                } else { // 点击关注
                    if (device.type === 3) {
                        this.$Message.warning(this.$t('l.hint41'))
                        return;
                    }
                    this.$emit('on-like', index);
                }
            },
            mouseEnter(device) {
                device.transtionShow = true
            },
            mouseLeave(device) {
                device.transtionShow = false;
            },

        },
        computed: {
            runStatus() {
                return {
                    '0': this.$t('l.no_datas'),
                    '1': this.$t('l.auto'),
                    '2': this.$t('l.repair'),
                    '3': this.$t('l.driver'),
                    '4': this.$t('l.special'),
                    '5': this.$t('l.fire'),
                    '6': this.$t('l.lock'),
                    '7': 'VIP',
                    '8': this.$t('l.fault')
                }
            }
        }
    }
</script>

<style lang="less" scoped>

    @font-face {
        font-family: 'signus_led';
        src: ~"url(/fonts/signus_led.eot) format('embedded-opentype'),
        url(/fonts/signus_led.woff) format('woff'),
        url(/fonts/signus_led.ttf)";
    }

    .lift-groups-card {
        color: white;
        position: relative;
        background: linear-gradient(to bottom, #ddd, #aaa);
        overflow: hidden;
        height: 130px;
        &.expire {
            background: linear-gradient(to bottom, #ddd, #aaa) !important;
        }
        &.online {
            &, &.status0 {
                /*无数据，状态0*/
                background: linear-gradient(to bottom, #479ee1, #479ee1);
            }
        }

        &.online {
            &.fault {
                background: linear-gradient(to bottom, #e74c3c, #c0392b);
            }
        }
        & .add {
            position: absolute;
            right: 5px;
            top: 5px;
            display: inline;
            cursor: pointer;
            z-index: 5;
        }
        & .bottom-info {
            position: absolute;
            display: inline-block;
            height: 1.4em;
            line-height: 1.4em;
            width: 100%;
            padding-left: 0.3em;
            left: 0;
            bottom: 0;
            font-size: 1em;
            background-color: rgba(0, 0, 0, 0.2);
            /*white-space: nowrap;*/
            cursor: default;
            transition: height 0.3s, background-color 0.3s;
            &:hover {
                height: 2.8em;
                background-color: rgba(0, 0, 0, 0.6);
            }
        }
        .lift-content {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            cursor: pointer;
            .like-icon {
                display: flex;
                & > img {
                    width: 20px;
                    height: 20px;
                }
            }
            .device-status-icons {
                height: 100%;
                width: calc(100% - (1.2em + 3.5em));
                padding: 0 10px;
                /*& > * {*/
                    /*position: absolute;*/
                /*}*/
                .icon-online-status {
                    height: 2em;
                    display: flex;
                    align-items: center;
                    height: 25%;
                    & > img {
                        width: 22px;
                        height: 22px;
                        margin-right: 5px;
                    }
                }
                .item-name {
                    font-weight: bolder;
                    width: 100%;
                    display: block;
                    font-size: 14px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    text-align: center;
                    margin-top: 10%;
                    height: 40%;
                }
                .capa-icons {
                    display: flex;
                    justify-content: end;
                    & > img {
                        width: 16px;
                        height: 16px;
                        float: left;
                        margin-left: 5px;
                    }
                }

                .lift-floor-now {
                    font-family: 'signus_led';
                    bottom: 0;
                    left: -60px;
                    font-weight: bolder;
                    font-size: 0.8em;
                    color: white;
                }
            }
            .device-type-icon {
                width: 3.5em;
                height: 4em;
                margin-left: 1.2em;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .more {
        width: 20px;
        height: 20px;
        cursor: pointer;
        margin-top: 5px;
    }

    .terminal_type {
        font-weight: 700;
        font-size: 12px;
        padding: 0 2px;
        border: 1px solid #fff;
        border-radius: 4px;
        width: 3.5em;
        text-align: center;
        margin-left: 1.2em;
        margin-top: 5px;
    }

    .menu-box {
        display: flex;
        position: absolute;
        top: 5px;
        right: 5px;
        z-index: 10;
        padding: 0px 4px;
        background-color: rgba(0,0,0,0.6);
    }

    /*.menu-box-mark {*/
        /*position: absolute;*/
        /*top: 0px;*/
        /*right: 5px;*/
        /*z-index: -1;*/
        /*opacity: 0.6;*/
        /*width: 85px;*/
        /*height: 25px;*/
        /*background-color: #000;*/
        /*border-radius: 4px;*/
    /*}*/

    .slide-fade-enter-active {
        transition: all .2s ease;
    }

    .slide-fade-leave-active {
        transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateX(10px);
        opacity: 0;
    }
    .guoqitixing {
        height: 18px;
        width: 18px;
        margin-top: 3px;
        margin-left: 5px;
    }
</style>